import React from 'react';
import { TitleImage, TooltipContainer } from './style';
import { Tooltip } from '@mui/material';

const QuestionTooltip = ({ text, img, onClickFn = () => {}, children }) => {
  return (
    <TooltipContainer onClick={onClickFn}>
      <Tooltip title={text} placement={'top'}>
        {children || <TitleImage src={img} />}
      </Tooltip>
    </TooltipContainer>
  );
};

export default QuestionTooltip;
